import { StringSchema } from 'yup';
import countries from 'i18n-iso-countries';
import {
  ADDRESS_MAX_LENGTH,
  EMAIL_MAX_LENGTH,
  NAME_MAX_LENGTH,
  PHONE_MAX_LENGTH,
  POSTAL_CODE_MAX_LENGTH,
  REGION_MAX_LENGTH,
} from '../../../constants';

export class CustomerSchema extends StringSchema {
  address(messages: { max?: string } = {}): this {
    return this.max(ADDRESS_MAX_LENGTH, messages?.max).trim();
  }

  email(messages: { max?: string; mobile?: string; format?: string }): this {
    return this.matches(/^(?!.+@docomo.+)/, messages?.mobile)
      .matches(/^(?!.+@au.+)/, messages?.mobile)
      .matches(/^(?!.+@softbank.+)/, messages?.mobile)
      .matches(/^(?!.+@ezweb.+)/, messages?.mobile)
      .max(EMAIL_MAX_LENGTH, messages?.max)
      .matches(
        /(^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$)/,
        messages?.format
      )
      .trim();
  }

  name(messages: { max?: string } = {}): this {
    return this.max(NAME_MAX_LENGTH, messages?.max).trim();
  }

  englishName(messages: { character?: string; max?: string } = {}): this {
    return this.matches(/^[a-z ,.'-]+$/i, messages?.character)
      .max(NAME_MAX_LENGTH, messages?.max)
      .trim();
  }

  // https://unicode.org/charts/PDF/U3040.pdf (Hiragana)
  // https://unicode.org/charts/PDF/U30A0.pdf (Katakana)
  japaneseName(messages: { character?: string; max?: string } = {}): this {
    return this.matches(/^[ぁ-ゞァ-ヾ]$/, messages?.character)
      .max(NAME_MAX_LENGTH, messages?.max)
      .trim();
  }

  // TODO: apply this validation to both account detail page and customer input page.
  // kanjiOrEnglishName(messages: { character?: string; max?: string } = {}): this {
  //   return this.matches(/^([a-z ,.'-,一-龠]+)?$/, messages?.character)
  //     .max(NAME_MAX_LENGTH, messages?.max)
  //     .trim();
  // }

  kanaOrAlphabetName(messages: { character?: string; max?: string } = {}): this {
    // eslint-disable-next-line no-irregular-whitespace
    return this.matches(/^([A-Za-z0-9０-９,ぁ-ゞ,ァ-ヶー,ｦ-ﾟ,-,\s　]+)?$/, messages?.character)
      .max(NAME_MAX_LENGTH, messages?.max)
      .trim();
  }

  phone(messages: { format?: string; whitespace?: string; max?: string } = {}): this {
    return this.max(PHONE_MAX_LENGTH, messages?.max)
      .matches(/^[+,-]?(?:[\d-]*\d[\d-]*)*$/gm, messages?.format)
      .trim();
  }

  country(messages: { oneOf?: string } = {}): this {
    return this.oneOf(
      Object.keys(countries.getAlpha2Codes()).map(
        (country) => country.toLowerCase(),
        messages?.oneOf
      )
    );
  }

  postalCode(messages: { max?: string; format?: string; whitespace?: string } = {}): this {
    return this.max(POSTAL_CODE_MAX_LENGTH, messages?.max)
      .matches(/^[a-zA-Z0-9]*([ -]?[a-zA-Z0-9]+)*$/gm, messages?.format)
      .trim();
  }

  region(messages: { max?: string; whitespace?: string } = {}): this {
    return (
      this
        // TODO: apply this validation to both account detail page and customer input page.
        // .matches(/^\S+$/, messages?.whitespace)
        .max(REGION_MAX_LENGTH, messages?.max)
        .trim()
    );
  }
}

function create(): CustomerSchema {
  return new CustomerSchema();
}

create.prototype = CustomerSchema.prototype;

export default create;
